<div *ngIf="display" class="company-selection" >
    <div class="select is-rounded">
        <select #logins [(ngModel)]="selected" [disabled]="disabled" (change)="onSelected(logins.value)">
            <option value="{{i}}" *ngFor="let login of userCompanyGroups; let i = index;">
                <span *ngIf="login.userid === login.companyLoginId">▶</span>
                <span *ngIf="login.userid !== login.companyLoginId">🔀</span>
                {{login.companyLogin.companyName}}</option>
        </select>
    </div>
</div>
